import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types'

// Redux
import { connect } from 'react-redux';

// Actions
import { getUnreadChats } from '../actions/chatActions';
import { getUnreadCount } from '../actions/notificationActions';
import { setPage, add_To_Recent_History } from '../actions/navActions';
import { setAlert } from '../actions/alertActions';
import { editUsername, changePassword, changeUserEmail, changeUserPhone, changeUserGender, changeUserBirthDate, checkIfEmailTaken } from '../actions/authActions';
import { toggleSideNav, goBack } from '../actions/navActions';

// Layout Components
import MainSettings from '../components/settings/Main_Settings';
import PaymentSettings from '../components/settings/Payments_Settings';
import TermsofService from '../components/settings/Terms_Settings';
import PrivacyPolicy from '../components/settings/Privacy_Policy';
import TrustSafety from '../components/settings/Trust_Settings';
import ReturnPolicy from '../components/settings/Returns_Settings';
import Help from '../components/settings/Help_Settings';
import Feedback from '../components/settings/Feedback_Settings';
import HowItWorks from '../components/settings/HowItWorks_Settings';
import About from '../components/settings/About_Settings';
import NavSettings from '../components/settings/Nav_Settings';

// Account pages
import ChangeUsername from '../components/settings/accountPages/Username';
import ChangePhone from '../components/settings/accountPages/Phone';
import ChangeEmail from '../components/settings/accountPages/Email';
import Verify_Email from '../components/settings/accountPages/Verify_Email';
import ChangeSchoolEmail from '../components/settings/accountPages/School_Email';
import Verify_School_Email from '../components/settings/accountPages/Verify_School_Email';
import ChangePassword from '../components/settings/accountPages/Password';
import ChangeGender from '../components/settings/accountPages/Gender';
import ChangeBirthDate from '../components/settings/accountPages/Birth_Date';

// Modal
import Modal from '../components/modal/Modal';
import ModalContainer from '../components/modal/ModalContainer';

// Components - imported
import { Button } from '@material-ui/core';
import Spinner from '../components/common/Spinner';
import MyActivity_Settings from '../components/settings/MyActivity_Settings';

const initialState = {
    username: '',
    phone: '',
    email: '',
    currentPassword: '',
    password: '',
    password2: '',
    month: '',
    day: '',
    year: '',
    school_email: ''
};

const Settings = ({ 
    getUnreadChats,
    getUnreadCount,
    goBack,
    setPage, 
    add_To_Recent_History,
    setAlert, 
    toggleSideNav, 
    editUsername, 
    changePassword, 
    changeUserEmail, 
    changeUserPhone, 
    changeUserGender, 
    changeUserBirthDate,
    auth, 
    nav, 
    chat,
    notification, 
    history 
}) => {
    
    // Screen Width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Which page to display
    const [page, handlePage] = useState(null);

    // Input field data
    const [formData, setFormData] = useState(initialState);

    const [gender, setGender] = useState(null);

    // Form processing - triggers disable button
    const [processing, setProcessing] = useState(false);

    // Edit Modal toggles
    const [usernameModal, setUsernameModal] = useState(false);
    const [emailModal, setEmailModal] = useState(false);
    const [phoneModal, setPhoneModal] = useState(false);
    const [passwordModal, setPasswordModal] = useState(true);

    // Get the current URL and extract the "redirect" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);

    useEffect(() => {

        // Update window width on resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Set the current page based to 'settings'
        setPage('settings');
        add_To_Recent_History(url.pathname);  // current url

        let pathname = window.location.pathname;

        const pathArray = pathname.split('/');

        const settingsPage = pathArray[pathArray.length - 1];

        console.log('Pathname');
        console.log(pathname);

        console.log('Settings Page');
        console.log(settingsPage);

        handlePage(settingsPage);

        // Load user data
        if (!auth.loading && auth.user) {

            // Create a copy of the initial form data with user values
            const userData = { ...initialState };
            for (const key in auth.user) {
                if (key in userData) userData[key] = auth.user[key];
            }
            if(auth.user.birth_date) {
                for (const key in auth.user.birth_date) {
                    if (key in userData) userData[key] = auth.user.birth_date[key];
                }
            }
            if(auth.user.gender) {

                // Set the selected gender based on the user's value
                if(auth.user.gender === 'male') {
                    setGender('male');
                } else if(auth.user.gender === 'female') {
                    setGender('female');
                } else if(auth.user.gender === 'other') {
                    setGender('other');
                }
            }

            // Clear password fields
            userData.password = '';
            userData.password2 = '';

            setFormData(userData);
        }
        
        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());

    }, [window.location, auth.user]);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };


    const { 
        username, 
        phone, 
        email, 
        currentPassword,
        password, 
        password2,
        month,
        day,
        year,
        school_email
    } = formData;

    // Edit info logic

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value});

    // Function to validate username format
    const validateUsername = (input) => {

        const validRegex = /^[A-Za-z0-9_-]+$/;
      
        if (input.match(validRegex)) {
      
          return true;
      
        } else {
      
          return false;
      
        }
    }

    // Function to validate email format
    const validateEmail = (input) => {

        var validRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/;
      
        if (input.match(validRegex)) {
      
          return true;
      
        } else {
      
          return false;
      
        }
    }

    // Function to validate phone number format
    const validatePhoneNumber = (input) => {

        const validRegex = /^\+?(?:\(\d{1,4}\)|\d{1,4})(?:[-.\s]?\d){6,14}$/;
      
        if (input.match(validRegex)) {
      
          return true;
      
        } else {
      
          return false;
      
        }
    }

    const usernameTodo = (e) => {
        e.preventDefault();
            
        if(username === '') {
            setAlert('Username is required.', 'danger');
        } else if (username.length < 4) {
            setAlert("Must be longer than 4 characters.", 'danger');
        } else if (!validateUsername(username)) {
            setAlert("Only letters, numbers, _ and -", 'danger');
        }  else {

            onSubmitUsername(e);
        }
    }

    const emailTodo = async (e) => {
        e.preventDefault();

        try {
            setProcessing(true);

            if(email === null || email === '') {
                setAlert('Email is required.', 'danger');
            } else if(email.toLowerCase() === auth.user.email.toLowerCase()) {
                setAlert('Enter a new email','danger');
            } else if (!validateEmail(email)) {
                setAlert("Invalid email address!", 'danger');
            } else if (await checkIfEmailTaken(email)) {
                setAlert("That email is taken.", 'danger');
            } else {
                window.location.href = `/settings/account/verify_email?email=${email.toLowerCase()}`;
                // onSubmitEmail(e);
            }
        } catch (error) {
            console.log('Error checking email: ', error);
            setAlert("Something went wrong!", 'danger');
            setProcessing(false);
        } finally {
            setProcessing(false);
        }
    }

    const phoneTodo = (e) => {
        onSubmitPhone(e);
    }

    const genderTodo = (e) => {
        onSubmitGender(e);
    }

    const birthDateTodo = (e) => {
        onSubmitBirthDate(e);
    }

    const passwordTodo = (e) => {
        onSubmitPassword(e);
    }

    const onSubmitUsername = async e => {
        e.preventDefault();

        if(auth.user) {
            const userId = auth.user_id; 

            editUsername({ 
                username,   
                userId
            });
            
            console.log('FRONT END ID')
            console.log(userId);
            console.log(username);
        }
    }

    // const onSubmitEmail = async e => {
    //     e.preventDefault();

    //     if(auth.user) {
    //         const userId = auth.user_id; 


    //         changeUserEmail({ 
    //             email,
    //             userId
    //         });

    //         console.log('FRONT END ID')
    //         console.log(userId);
    //         console.log(email);
    //     }
    // }

    const onSubmitPhone = async e => {
        e.preventDefault();

        let phone_trimmed = phone.trim();
        if(auth.user) {
            const userId = auth.user_id; 

            if(phone_trimmed === null || phone_trimmed === '') {
                setAlert('A phone # is required', 'danger');
            } else if(!validatePhoneNumber(phone_trimmed)) {
                setAlert('Invalid phone #', 'danger');
            } else {
                changeUserPhone({ 
                    phone: phone_trimmed,
                    userId
                });
            }

            console.log('FRONT END ID')
            console.log(userId);
            console.log(phone_trimmed);
        }
    }

    const onSubmitGender = async e => {
        e.preventDefault();

        if(auth.user) {
            const userId = auth.user_id; 

            if(gender === null || gender === '') {
                setAlert('Must select a gender', 'danger');
            } else {
                changeUserGender({ 
                    gender,
                    userId
                });
            }

            console.log('FRONT END ID')
            console.log(userId);
            console.log(gender);
        }
    }

    const onSubmitBirthDate = async e => {
        e.preventDefault();

        if(auth.user) {
            const userId = auth.user_id; 

            if(month === '' || day === '' || year === '') {
                setAlert('Please fill in all the fields', 'danger');
            } else {
                changeUserBirthDate({ 
                    month,
                    day,
                    year,
                    userId
                });
            }

            console.log('FRONT END ID')
            console.log(userId);
            console.log(gender);
        }
    }

    const onSubmitPassword = async e => {
        e.preventDefault();

        if(auth.user) {
            const userId = auth.user_id; 

            if(currentPassword === '') {
                setAlert('Current password required', 'danger');
                // TODO: CHECK IF CURRENT PASSWORD IS VALID
            } else if(password === '') {
                setAlert('Please enter a new password', 'danger');
            } else if(password2 === '') {
                setAlert('Must re-enter new password', 'danger');
            } else if(password !== password2) {
                setAlert('Passwords do not match', 'danger');
            } else if(password.length < 6) {
                setAlert('Passwords must be 6+ characters', 'danger');
            } else {
                changePassword({ 
                    password, 
                    currentPassword,
                    userId 
                });
            }
        }
    }

    // Modal toggle logic

    const toggleUsernameModal = () => {
        setUsernameModal(!usernameModal);
    }

    const toggleEmailModal = () => {
        setEmailModal(!emailModal);
    }

    const togglePhoneModal = () => {
        setPhoneModal(!phoneModal);
    }

    const togglePasswordModal = () => {
        setPasswordModal(!passwordModal);
    }

    const bg = {
        modal: {
            paddingLeft: "0",
            paddingRight: "0",
            border:"1px solid rgb(214,214,214)",
            boxShadow: "none"
        },
        overlay: {
          background: "rgba(255,255,255,0.5)"
        }
    };

    // Determine mobile and tablet screen sizes
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    return (
        <Fragment>
            <div className="inbox__container">
                
                {/* Navigation */}
                {!isTablet && (
                    <NavSettings 
                        sideNav={nav.sideNav} 
                        handleSlideMenu={toggleSideNav} 
                        auth={auth} 
                        page={nav.page} 
                        chat={chat}
                        notification={notification} 
                        history={history} 
                        getUnreadChats={getUnreadChats}
                        getUnreadCount={getUnreadCount}
                        goBack={goBack}
                    />
                )}

                {/* Account pages */}
                {page == 'account' && <MainSettings handleSlideMenu={toggleSideNav} formData={formData} toggleUsernameModal={toggleUsernameModal} toggleEmailModal={toggleEmailModal} togglePhoneModal={togglePhoneModal} togglePasswordModal={togglePasswordModal} history={history} auth={auth} chat={chat} notification={notification} nav={nav} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} />}

                {/* Individual account pages */}

                {auth.loading && ['screen_name', 'password', 'email', 'verify_email', 'school_email', 'verify_school_email', 'phone', 'gender', 'birth_date'].includes(page) ? (
                    <Spinner />
                ) : (
                    <Fragment>
                        {page == 'screen_name' && <ChangeUsername username={username} usernameTodo={usernameTodo} onChange={onChange} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                        {page == 'password' && <ChangePassword currentPassword={currentPassword} password={password} password2={password2} passwordTodo={passwordTodo} onChange={onChange} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                        {page == 'email' && <ChangeEmail email={email} emailTodo={emailTodo} processing={processing} onChange={onChange} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                        {page == 'verify_email' && <Verify_Email getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                        {page == 'school_email' && <ChangeSchoolEmail school_email={school_email} onChange={onChange} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                        {page == 'verify_school_email' && <Verify_School_Email getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                        {page == 'phone' && <ChangePhone phone={phone} phoneTodo={phoneTodo} onChange={onChange} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                        {page == 'gender' && <ChangeGender gender={gender} setGender={setGender} genderTodo={genderTodo} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                        {page == 'birth_date' && <ChangeBirthDate month={month} day={day} year={year} onChange={onChange} birthDateTodo={birthDateTodo} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}
                    </Fragment>
                )}

                {/* End */}

                {/* My Activity pages */}
                {page == 'activity' && <MyActivity_Settings handleSlideMenu={toggleSideNav} formData={formData} toggleUsernameModal={toggleUsernameModal} toggleEmailModal={toggleEmailModal} togglePhoneModal={togglePhoneModal} togglePasswordModal={togglePasswordModal} history={history} auth={auth} chat={chat} notification={notification} nav={nav} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} />}

                {/* Other setting pages */}
                {page == 'payments' && <PaymentSettings handleSlideMenu={toggleSideNav} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                {page == 'howitworks' && <HowItWorks handleSlideMenu={toggleSideNav} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                {page == 'about' && <About handleSlideMenu={toggleSideNav} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                {page == 'help' && <Help handleSlideMenu={toggleSideNav} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                {page == 'feedback' && <Feedback handleSlideMenu={toggleSideNav} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                {page == 'returns' && <ReturnPolicy handleSlideMenu={toggleSideNav} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                {page == 'trust_and_safety' && <TrustSafety handleSlideMenu={toggleSideNav} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                {page == 'terms' && <TermsofService handleSlideMenu={toggleSideNav} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}

                {page == 'privacy' && <PrivacyPolicy handleSlideMenu={toggleSideNav} history={history} auth={auth} chat={chat} notification={notification} getUnreadChats={getUnreadChats} getUnreadCount={getUnreadCount} goBack={goBack} />}
                
            </div>
        </Fragment>
    )
}

Settings.propTypes = {
    auth: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    chat: PropTypes.object.isRequired,
    notification: PropTypes.object.isRequired,
    getUnreadChats: PropTypes.func.isRequired,
    getUnreadCount: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    add_To_Recent_History: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    toggleSideNav: PropTypes.func.isRequired,
    editUsername: PropTypes.func.isRequired,
    changePassword: PropTypes.func.isRequired, 
    changeUserEmail: PropTypes.func.isRequired,
    changeUserPhone: PropTypes.func.isRequired,
    changeUserGender: PropTypes.func.isRequired,
    changeUserBirthDate: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    auth: state.auth,
    nav: state.nav,
    chat: state.chat,
    notification: state.notification
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    getUnreadChats,
    getUnreadCount,
    setPage, 
    add_To_Recent_History,
    setAlert, 
    toggleSideNav, 
    editUsername, 
    changePassword, 
    changeUserEmail, 
    changeUserPhone,
    changeUserGender, 
    changeUserBirthDate,
    goBack
})(Settings);
